var wizardFunctions = {
    created: function () {
    },
    methods: {       
        setUploadFile(ev, form, $v) {
            form[ev.currentTarget.name] = ev.currentTarget.files[0];
            if(form[ev.currentTarget.name] != null)
                return form[ev.currentTarget.name + "Name"] = form[ev.currentTarget.name].name;
            return form[ev.currentTarget.name + "Name"] = 'Kies een document...';
        },
        onSetPhoto (image, form, $v) {
            $v.form.profileImage.$touch();
            if (image) {
                var type = image.substring(image.indexOf(":") + 1, image.indexOf(";"));
                form.profileImage = this.b64ToFile(image.split(',')[1], type, 'profileImage.' + type.split("/")[1]);
            }
        },
        saveProperty(type, ev) {
            const validation = this.$v.form[ev.currentTarget.name];
            if(validation.$invalid)
                return;

            this.$http.post('api/Profile/' + type + '/Wizard/SaveProperty/' + ev.currentTarget.name, JSON.stringify(ev.currentTarget.value)).then(() =>
            {
                validation.$touch();
            })
        }
    }
};

export default wizardFunctions;